import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Input, notification } from "antd";
import { AllTypoFontStyles, SettingsStyles } from "../../../Styles/styles";
import {
  useUpdateUserProfileMutation,
  useGetProfileInformationQuery,
} from "../../../Redux/apis/ApiSlice";
export default function ProfileTab() {
  const theme = useTheme();
  const [userData, setUserData] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    profilePicture: "", // Add profilePicture to state
  });

  // Mutation hook
  const [updateUserProfile] = useUpdateUserProfileMutation();
  const {
    data: profileData,
    refetch,
  } = useGetProfileInformationQuery();

  const isLgDown = useMediaQuery(theme.breakpoints.down("lg"));
  const InputStyles = {
    FieldStyle: {
      height: "47px",
      width: isLgDown ? "100%" : "429px",
    },
  };

  // Function to reset form fields using profileData
  const resetFormFields = () => {
    if (profileData) {
      setUserData({
        fullName: profileData.user.fullName || "",
        email: profileData.user.email || "",
        phoneNumber: profileData.user.phoneNumber || "",
        profilePicture: profileData.user.profilePic || "",
      });
    }
  };

  // Populate form fields when profileData changes
  useEffect(() => {
    resetFormFields();
  }, [profileData]);

  // Handler for the update button
  const handleUpdateClick = async () => {
    const { fullName, email, phoneNumber, profilePicture } = userData; // Use the state directly

    // Prepare user data object
    const userDataToUpdate = {
      fullName,
      email,
      phoneNumber,
      profilePic: profilePicture || null, // Use the updated profile picture URL
    };

    // Validation checks to ensure required fields are filled
    if (!fullName) {
      notification.error({
        
        message: "Full Name is required!",
      });
      return;
    }

    if (!email) {
      notification.error({
        
        message: "Email is required!",
      });
      return;
    }

    if (!phoneNumber) {
      notification.error({
        
        message:
          "Phone Number is required!",
      });
      return;
    }

    try {
      // Call the API to update the user profile
      // await updateUserProfile(userDataToUpdate).unwrap();
      const updatedProfile = await updateUserProfile(userDataToUpdate).unwrap();
      // Update local state with the returned data from the server
      setUserData((prevData) => ({
        ...prevData,
        profilePicture: updatedProfile.profilePic || prevData.profilePicture, // Use the returned URL
      }));

      // If the API call is successful, show a success notification
      notification.success({
        
        message: "Profile updated successfully!",
      });
      refetch();
    } catch (error) {
      // Handle any errors that occur during the API call
      console.error("Failed to update profile:", error);
      notification.error({
        
        message: "Failed to update profile!",
      });
    }
  };

  return (
    <>
      <div>
        <Box p={3} sx={{ overflowX: "hidden" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Box mt={3}>
                <Box mb={2}>
                  <Typography sx={AllTypoFontStyles.CommonTypo2}>
                    Full Name
                  </Typography>
                  <Input
                    size="large"
                    placeholder="Full Name"
                    name="name"
                    style={InputStyles.FieldStyle}
                    value={userData.fullName}
                    onChange={(e) =>
                      setUserData({ ...userData, fullName: e.target.value })
                    }
                  />
                </Box>
                <Box mb={2}>
                  <Typography sx={AllTypoFontStyles.CommonTypo2}>
                    Email
                  </Typography>
                  <Input
                    size="large"
                    placeholder="Email"
                    name="email"
                    style={InputStyles.FieldStyle}
                    value={userData.email}
                    onChange={(e) =>
                      setUserData({ ...userData, email: e.target.value })
                    }
                  />
                </Box>
                <Box mb={2}>
                  <Typography sx={AllTypoFontStyles.CommonTypo2}>
                    Phone Number
                  </Typography>
                  <Input
                    size="large"
                    placeholder="Phone No"
                    name="phone"
                    style={InputStyles.FieldStyle}
                    value={userData.phoneNumber}
                    onChange={(e) =>
                      setUserData({ ...userData, phoneNumber: e.target.value })
                    }
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
          <Box
            sx={{
              display: "flex",
              // mr: 2,
              float: "right",
              flexDirection: { md: "row", sm: "column", xs: "column" },
              gap: 1,
            }}
          >
            <Button
              onClick={resetFormFields}
              sx={SettingsStyles.ResetBtnStyles}
              variant="outlined"
            >
              Reset Changes
            </Button>
            <Button
              sx={SettingsStyles.UpdateBtnStyles}
              variant="contained"
              color="primary"
              onClick={handleUpdateClick}
            >
              Update
            </Button>
          </Box>
        </Box>
      </div>
    </>
  );
}
